// InfoWindow.js
import Mustache from 'mustache'

export default class InfoWindow {
    constructor(infoLayers) {
        const el = document.getElementById("info-box")
        if (!el) throw new Error(`Container "${containerId}" introuvable`)
        this.container = el
        this.infoLayers = infoLayers
        this.hoveredFeatures = []
    }

    // Trouver le template correspondant à la couche
    getTemplateForLayer(layerName) {
        const layer = this.infoLayers.find(l => l.layername === layerName)
        return layer ? layer.template : '<p>Aucune information disponible.</p>'
    }

    // Mettre à jour les features survolées
    updateHoveredFeatures(features) {
        this.hoveredFeatures = features
        this.render()
    }

    // Générer le HTML Mustache
    render() {
        if (!this.hoveredFeatures.length) {
            this.container.innerHTML = ''
            return
        }

        const html = this.hoveredFeatures.map(f => {
            if (f.layer && f.layer.id) {
                return Mustache.render(
                    this.getTemplateForLayer(f.layer.id),
                    f.properties
                )
            } else {
                return '<p>Feature sans couche associée.</p>'
            }
        }).join('')

        this.container.innerHTML = html
    }
}